// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* 中央揃え & 可変幅（paddingで調整） */
.cb-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  font-weight: 600;
  line-height: 1;
  border: 1px solid transparent;
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
  -webkit-tap-highlight-color: transparent;

  transition: background-color 120ms ease, color 120ms ease,
              border-color 120ms ease, box-shadow 120ms ease;
}

/* サイズ */
.cb-btn--md { font-size: 16px; padding: 13px 20px 12px 20px; }
.cb-btn--sm { font-size: 14px; padding: 8px 12px 6px 12px; }

/* 幅オプション */
.cb-btn--full { width: 100%; }

/* 無効状態 */
.cb-btn:disabled {
  opacity: 0.45;
  cursor: not-allowed;
}

/* キーボード操作の可視フォーカス */
.cb-btn:focus-visible {
  outline: none;
  box-shadow: 0 0 0 3px rgba(15, 98, 254, 0.35);
}

/* ===== バリアント ===== */

/* Primary */
.cb-btn--primary {
  background: #0f62fe; /* Blue60 相当 */
  color: #ffffff;
  border-color: transparent;
}
.cb-btn--primary:hover:not(:disabled)  { background: #0353e9; }
.cb-btn--primary:active:not(:disabled) { background: #002d9c; }

/* Secondary（グレー系） */
.cb-btn--secondary {
  background: #e0e0e0;
  color: #161616;
  border-color: transparent;
}
.cb-btn--secondary:hover:not(:disabled)  { background: #c6c6c6; }
.cb-btn--secondary:active:not(:disabled) { background: #a8a8a8; }

/* Tertiary（薄い枠+リンク色） */
.cb-btn--tertiary {
  background: transparent;
  color: #0f62fe;
  border-color: rgba(15, 98, 254, 0.35);
}
.cb-btn--tertiary:hover:not(:disabled)  { background: #edf5ff; }
.cb-btn--tertiary:active:not(:disabled) { background: #d0e2ff; }

/* Ghost（枠なしテキストライク） */
.cb-btn--ghost {
  background: transparent;
  color: #0f62fe;
  border-color: transparent;
}
.cb-btn--ghost:hover:not(:disabled)  { background: #f4f4f4; }
.cb-btn--ghost:active:not(:disabled) { background: #e8e8e8; }

/* Danger（削除・破壊的操作用） */
.cb-btn--danger {
  background: #da1e28; /* Red60 相当 */
  color: #ffffff;
  border-color: transparent;
}
.cb-btn--danger:hover:not(:disabled)  { background: #ba1b23; } /* Red70 */
.cb-btn--danger:active:not(:disabled) { background: #750e13; } /* Red80 */`, "",{"version":3,"sources":["webpack://./src/components/CustomButton.css"],"names":[],"mappings":"AAAA,2BAA2B;AAC3B;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,gBAAgB;EAChB,cAAc;EACd,6BAA6B;EAC7B,eAAe;EACf,yBAAiB;UAAjB,iBAAiB;EACjB,wCAAwC;;EAExC;4DAC0D;AAC5D;;AAEA,QAAQ;AACR,cAAc,eAAe,EAAE,4BAA4B,EAAE;AAC7D,cAAc,eAAe,EAAE,0BAA0B,EAAE;;AAE3D,WAAW;AACX,gBAAgB,WAAW,EAAE;;AAE7B,SAAS;AACT;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA,oBAAoB;AACpB;EACE,aAAa;EACb,6CAA6C;AAC/C;;AAEA,sBAAsB;;AAEtB,YAAY;AACZ;EACE,mBAAmB,EAAE,cAAc;EACnC,cAAc;EACd,yBAAyB;AAC3B;AACA,yCAAyC,mBAAmB,EAAE;AAC9D,yCAAyC,mBAAmB,EAAE;;AAE9D,oBAAoB;AACpB;EACE,mBAAmB;EACnB,cAAc;EACd,yBAAyB;AAC3B;AACA,2CAA2C,mBAAmB,EAAE;AAChE,2CAA2C,mBAAmB,EAAE;;AAEhE,uBAAuB;AACvB;EACE,uBAAuB;EACvB,cAAc;EACd,qCAAqC;AACvC;AACA,0CAA0C,mBAAmB,EAAE;AAC/D,0CAA0C,mBAAmB,EAAE;;AAE/D,sBAAsB;AACtB;EACE,uBAAuB;EACvB,cAAc;EACd,yBAAyB;AAC3B;AACA,uCAAuC,mBAAmB,EAAE;AAC5D,uCAAuC,mBAAmB,EAAE;;AAE5D,sBAAsB;AACtB;EACE,mBAAmB,EAAE,aAAa;EAClC,cAAc;EACd,yBAAyB;AAC3B;AACA,wCAAwC,mBAAmB,EAAE,EAAE,UAAU;AACzE,wCAAwC,mBAAmB,EAAE,EAAE,UAAU","sourcesContent":["/* 中央揃え & 可変幅（paddingで調整） */\n.cb-btn {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 0.5rem;\n  font-weight: 600;\n  line-height: 1;\n  border: 1px solid transparent;\n  cursor: pointer;\n  user-select: none;\n  -webkit-tap-highlight-color: transparent;\n\n  transition: background-color 120ms ease, color 120ms ease,\n              border-color 120ms ease, box-shadow 120ms ease;\n}\n\n/* サイズ */\n.cb-btn--md { font-size: 16px; padding: 13px 20px 12px 20px; }\n.cb-btn--sm { font-size: 14px; padding: 8px 12px 6px 12px; }\n\n/* 幅オプション */\n.cb-btn--full { width: 100%; }\n\n/* 無効状態 */\n.cb-btn:disabled {\n  opacity: 0.45;\n  cursor: not-allowed;\n}\n\n/* キーボード操作の可視フォーカス */\n.cb-btn:focus-visible {\n  outline: none;\n  box-shadow: 0 0 0 3px rgba(15, 98, 254, 0.35);\n}\n\n/* ===== バリアント ===== */\n\n/* Primary */\n.cb-btn--primary {\n  background: #0f62fe; /* Blue60 相当 */\n  color: #ffffff;\n  border-color: transparent;\n}\n.cb-btn--primary:hover:not(:disabled)  { background: #0353e9; }\n.cb-btn--primary:active:not(:disabled) { background: #002d9c; }\n\n/* Secondary（グレー系） */\n.cb-btn--secondary {\n  background: #e0e0e0;\n  color: #161616;\n  border-color: transparent;\n}\n.cb-btn--secondary:hover:not(:disabled)  { background: #c6c6c6; }\n.cb-btn--secondary:active:not(:disabled) { background: #a8a8a8; }\n\n/* Tertiary（薄い枠+リンク色） */\n.cb-btn--tertiary {\n  background: transparent;\n  color: #0f62fe;\n  border-color: rgba(15, 98, 254, 0.35);\n}\n.cb-btn--tertiary:hover:not(:disabled)  { background: #edf5ff; }\n.cb-btn--tertiary:active:not(:disabled) { background: #d0e2ff; }\n\n/* Ghost（枠なしテキストライク） */\n.cb-btn--ghost {\n  background: transparent;\n  color: #0f62fe;\n  border-color: transparent;\n}\n.cb-btn--ghost:hover:not(:disabled)  { background: #f4f4f4; }\n.cb-btn--ghost:active:not(:disabled) { background: #e8e8e8; }\n\n/* Danger（削除・破壊的操作用） */\n.cb-btn--danger {\n  background: #da1e28; /* Red60 相当 */\n  color: #ffffff;\n  border-color: transparent;\n}\n.cb-btn--danger:hover:not(:disabled)  { background: #ba1b23; } /* Red70 */\n.cb-btn--danger:active:not(:disabled) { background: #750e13; } /* Red80 */"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
